import axios from 'axios';

export function getStatusFromError(error: unknown) {
  if (!axios.isAxiosError(error)) {
    return undefined;
  }

  return error.response?.status;
}
